import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import type { FMR1Fields } from "../../../../../api/fmr1";
import { useAppDispatch, useAppSelector } from "../../../../../app/store";
import { DraftFMR1Fields, selectFMR1DraftFmrFields, updateFMR1DraftField } from "../../../logic/frm1Slice";
import FmrTwoColumnTable, { FmrTwoColumnTableRowProps } from "../common/fmrTwoColumnTable";

export const GENERAL_INFORMATION_ROWS: Array<FmrTwoColumnTableRowProps<DraftFMR1Fields>> = [
  { label: "Return Name", key: "general_information_name", type: "text" },
  { label: "Return Code", key: "general_information_code", type: "text" },
  {
    label: "Reporting Institution",
    key: "general_information_reporting_institution",
    type: "text",
  },
  {
    label: "Reporting Entity Code",
    key: "general_information_reporting_entity_code",
    type: "text",
  },
  {
    label: "RBI Regional Office Name",
    key: "general_information_rbi_regional_office_name",
    type: "text",
  },
  {
    label: "For the quarter ended",
    key: "general_information_quarter_ended",
    type: "date",
  },
  {
    label: "Date of Report",
    key: "general_information_date_of_report",
    type: "date",
  },
  {
    label: "Reporting Frequency",
    key: "general_information_reporting_frequency",
    type: "text",
  },
  {
    label: "Return Version",
    key: "general_information_return_version",
    type: "text",
  },
  {
    label: "Reporting Period Start Date",
    key: "general_information_reporting_period_start_date",
    type: "date",
  },
  {
    label: "Number of frauds to be submitted in this particular filing",
    key: "general_information_number_of_frauds_submitted",
    type: "number",
  },
];

const FMR1GeneralInformationForm: React.FC = () => {
  const { id: case_id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const draftFields = useAppSelector(selectFMR1DraftFmrFields);

  const handleFieldChange = useCallback((key: keyof DraftFMR1Fields, value: any) => {
    if (!case_id) return;
    dispatch(updateFMR1DraftField({ key, value }));
  }, [case_id, dispatch]);

  return (
    <>
      <FmrTwoColumnTable<FMR1Fields>
        data={draftFields}
        onChange={handleFieldChange}
        rows={GENERAL_INFORMATION_ROWS}
        leftWidthPx={270}
        rowHeightPx={44}
        className="overflow-visible"
      />
      <div className="h-20" />
    </>
  );
};

FMR1GeneralInformationForm.displayName = "FMR1GeneralInformationForm";

export default FMR1GeneralInformationForm;
